import { render, staticRenderFns } from "./BlockListArchiveItems.vue?vue&type=template&id=33acdf64&scoped=true&"
import script from "./BlockListArchiveItems.vue?vue&type=script&lang=ts&"
export * from "./BlockListArchiveItems.vue?vue&type=script&lang=ts&"
import style0 from "./BlockListArchiveItems.vue?vue&type=style&index=0&id=33acdf64&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33acdf64",
  null
  
)

export default component.exports